interface AppRoute {
  FURUSATO_NOZEI: {
    PAYMENT: string;
    ROOT: string;
    V2ROOT: string;
    THANK_YOU_GIFT: string;
    THANK_YOU_GIFT_DETAIL: string;
    WHAT_IS_FURUSATO_NOZEI: string;
    STORES: string;
    HISTORY: string;
    USE_HISTORY: string;
    INFO_MEMBER: string;
    TOP: string;
    SUCCESS_NOTIFICATION: string;
    SUCCESS_NOTIFICATION_METAPS: string;
    SEARCH_COUPON: string;
    SEARCH_1PT: string;
    RELEASE: string;
    SCAN: string;
    HISTORY_DETAIL: string;
    SUCCESSFUL_USE: string;
    QA: string;
    SIMULATION: string;
    ONE_STOP_USER_MANUAL: string;
    LOGIN: string;
    REGISTER: string;
    NOTIFICATIONS: string;
    HOW_TO_USE: string;
    TERMS: string;
    HISTORY_POINT_EXPIRED: string;
  };

  PREMIUM_VOUCHER: {
    ROOT: string;
    SUCCESS_NOTIFICATION: string;
    RELEASE: string;
    WHAT_IS: string;
    LIST_VOUCHER: string;
    DETAIL_VOUCHER: string;
    PAYMENT: string;
    SEARCH: string;
    POST_CODE: string;
    INFO_MEMBER: string;
    TOP: string;
    HISTORY: string;
    USE_HISTORY: string;
    HISTORY_DETAIL: string;
    SUCCESSFUL_USE: string;
    QA: string;
  };

  NOT_FOUND: string;
}

export const appRoutes: AppRoute = {
  FURUSATO_NOZEI: {
    ROOT: 'furusato-nozei',
    V2ROOT: 'furusato-nozei-v2',
    TOP: 'top',
    THANK_YOU_GIFT: 'list',
    THANK_YOU_GIFT_DETAIL: 'detail',
    STORES: 'stores',
    PAYMENT: 'payment',
    SEARCH_COUPON: 'search-coupon',
    SEARCH_1PT: 'search-one-point',
    RELEASE: 'release',
    SUCCESS_NOTIFICATION: 'success-notification',
    SUCCESS_NOTIFICATION_METAPS: 'payment-success',
    WHAT_IS_FURUSATO_NOZEI: 'what-is-furusato-nozei',
    HISTORY: 'history',
    USE_HISTORY: 'use-history',
    INFO_MEMBER: 'info-member',
    SCAN: 'scan-qr',
    HISTORY_DETAIL: 'history-detail',
    SUCCESSFUL_USE: 'successful-use',
    QA: 'qa',
    SIMULATION: 'simulation',
    ONE_STOP_USER_MANUAL: 'one-stop-user-manual',
    LOGIN: 'login',
    REGISTER: 'register',
    NOTIFICATIONS: 'notifications',
    HOW_TO_USE: 'how_to_use',
    TERMS: 'terms',
    HISTORY_POINT_EXPIRED: 'history-point-expired'
  },

  PREMIUM_VOUCHER: {
    ROOT: 'premium-voucher',
    SUCCESS_NOTIFICATION: 'success-notification',
    RELEASE: 'release',
    WHAT_IS: 'what-is',
    LIST_VOUCHER: 'list',
    DETAIL_VOUCHER: 'detail',
    PAYMENT: 'payment',
    SEARCH: 'search-voucher',
    POST_CODE: 'post-code',
    INFO_MEMBER: 'info-member',
    TOP: 'top',
    HISTORY: 'history',
    USE_HISTORY: 'use-history',
    HISTORY_DETAIL: 'history-detail',
    SUCCESSFUL_USE: 'successful-use',
    QA: 'qa',
  },

  NOT_FOUND: '404',
};
